
<template>
  <div class="order-div" v-loading="loading" element-loading-text="订单生成中" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.2)">
    <div class="order-div-cy">
      <div class="order-div-cy-div">
        <span style="cursor: pointer;" @click="goBack">
          < 返回订单</span>
      </div>
    </div>
    <div class="order-div-nr mainContainer">
      <el-card class="box-card" body-style="padding:0" v-if="notTj">
        <div slot="header" class="clearfix">
          <span>订单信息</span>
        </div>
        <div style="padding: 20px;">
          <div class="text item">
            商品信息
          </div>
          <div class="orderList">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="date" label="商品详情" width="774" align="center">
                <template slot-scope="scope">
                  <div class="disFlex">
                    <div class="" style="width: 129px;height: 77px;background-color: #e6e6e6;"><img
                        style="width: 129px;height: 77px;" :src="wjSrc+productInfo.img" /></div>
                    <div class="goodsXq">
                      <div>{{productInfo.cname}}</div>
                      <div style="color: #9a9a9a;">总课时：{{productInfo.xstime}} | {{productInfo.buyamount}}人购买 |
                        有效期：{{productInfo.endtime}}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="购买数量" width="191" align="center">
                <template slot-scope="scope">
                  {{num}}
                  <!-- <el-input-number v-model="num" disabled @change="handleChange" :min="1" label="描述文字" size="small">
                  </el-input-number> -->
                </template>
              </el-table-column>
              <el-table-column prop="name" label="实付价格" width="191" align="center">
                <template slot-scope="scope">
                  <span style="color: #333333;">¥{{(productInfo.price)*num}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="text item" style="margin-bottom: 20px;">支付信息</div>
          <div>
            <div class="priceYouhui disFlex between"><span class="flex1"
                style="text-align: right;color: #9a9a9a;">原价：</span><span class="flex1"
                style="text-align: left;">¥{{(productInfo.price)*num}}</span></div>
            <div class="priceYouhui disFlex between"><span class="flex1"
                style="text-align: right;color: #9a9a9a;">已优惠：</span><span class="flex1"
                style="text-align: left;">-¥0</span></div>
            <div class="priceYouhui disFlex between"><span class="flex1"
                style="text-align: right;color: #9a9a9a;">实付：</span><span class="flex1"
                style="text-align: left;">¥{{(productInfo.price)*num}}</span></div>
          </div>
          <div class="text item" style="margin: 20px 0;">支付方式</div>
          <div class="disFlex" style="width: 780px;">
            <div :class="payitype=='1'?'flex1 pay active':'flex1 pay'" @click="changePay(1)">微信支付</div>
            <div :class="payitype=='2'?'flex1 pay active':'flex1 pay'" @click="changePay(2)">支付宝支付</div>
            <div :class="payitype=='3'?'flex1 pay active':'flex1 pay'" @click="changePay(3)">银联个人支付</div>
            <div :class="payitype=='4'?'flex1 pay active':'flex1 pay'" @click="changePay(4)">银联公司支付</div>
          </div>
        </div>
        <div class="cardFooter">
          <div class="disFlex">
            <span class="shouldPay">应付金额：</span>
            <span class="shouldMoney">¥{{(productInfo.price)*num}}</span>
            <el-button type="primary" style="width: 171px;border-radius: 22px;" @click="tiaojiao()">立即支付</el-button>
          </div>
        </div>
      </el-card>

      <el-card class="box-card" v-if="!notTj">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px;color: #4a4a4a;font-weight: 500;letter-spacing: 1px;"><i class="el-icon-back" style="cursor: pointer;padding-right: 3px;" @click="changeTjstate(true)"></i>商品订单：{{orderNum}}</span>
          <span
            style="float: right; padding: 3px 0;display: inline-block;color: #d50000;letter-spacing: 1px;font-size: 24px;">¥{{(productInfo.price)*num}}</span>
        </div>
        <div class="disFlex between" style="width: 598px;margin: 0 auto;align-items: center;">
          <div>
            <div id="Eweima" ref="qrCodeDiv" v-if="!notTj"></div>
            <div class="sysbtn">请打开手机微信，扫一扫完成支付</div>
          </div>
          <div>
            <img src="@/assets/images/saoyisao.png" />
          </div>
        </div>

      </el-card>

    </div>

  </div>
</template>

<script>
  // 可生成二维码
  import QRCode from 'qrcodejs2';
  export default {
    name: 'Order',
    props: ['wjSrc'],
    data() {
      return {
        tableData: [{
          content: '公示公共',
          creatTime: '2021-06-30 12:00:03'
        }],
        payitype: 1,
        notTj: true,
        orderNum: '',
        productInfo: {},
        num: 1,
        loading: false,
        payTimeInter: null,
        payTimeNum: 0
      }
    },
    methods: {
      changePay: function(pay) {
        this.payitype = pay;
      },
      goBack: function() {
        this.$router.go(-1); //返回上一层
      },
      handleChange: function() {

      },
      tiaojiao: function() {
        // 支付方式 1 微信 2 支付宝 3 银联
        // if (this.payitype == '1') {
        //   this.payOpenWx(this.orderNum, this.productInfo.cname, (this.productInfo.price)*this.num)
        // } else if (this.payitype == '2') {
        //   this.payOpenZfb(this.orderNum, this.productInfo.cname, (this.productInfo.price)*this.num)
        // } else if (this.payitype == '3') {
        //   this.payOpenYl(this.orderNum, this.productInfo.cname, (this.productInfo.price)*this.num, '000201')
        // } else if (this.payitype == '4') {
        //   this.payOpenYl(this.orderNum, this.productInfo.cname, (this.productInfo.price)*this.num, '000202')
        // }
      },
      // 微信支付
      payOpenWx: function(id, cname, price) {
        var $this = this;
        var wx = {
          "flag": "native",
          "out_trade_no": id,
          "description": cname,
          "total": price*100
        }
        // 生成微信支付订单
        this.$axios.post('/prevention/pay/WX.htm', wx, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            'Content-Type': 'application/json;charset=utf8'
          }
        }).then(res => {
          var data = res.data;
          this.loading = false;
          this.notTj = false;
          if (data.stat == '1') {
            setTimeout(function() {
              $this.bindQRCode(data.data.code_url, id);
            }, 300)
          } else {
            this.$message.error(data.message);
          }
        })
      },
      // 支付宝支付
      payOpenZfb: function(id, cname, price) {
        var $this = this;
        var zfb = {
          "out_trade_no": id,
          "subject": cname,
          "total": price
        }
        // 生成微信支付订单
        this.$axios.post('/prevention/pay/ZFB.htm', zfb, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            'Content-Type': 'application/json;charset=utf8'
          }
        }).then(res => {
          var data = res.data;
          this.loading = false;
          if (data && data.data && data.data.body) {
            //// 添加之前先删除一下，如果单页面，页面不刷新，添加进去的内容会一直保留在页面中，二次调用form表单会出错
            let divForm = document.getElementsByTagName('divform')
            if (divForm.length) {
              document.body.removeChild(divForm[0])
            }

            const div = document.createElement('divform');
            div.innerHTML = data.data.body; // data就是接口返回的form 表单字符串
            document.body.appendChild(div);
            document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
            document.forms[0].submit();

            var $this = this;
            this.payTimeNum = 0;
            // 支付状态查询
            this.payTimeInter = setInterval(function() {
              $this.getPayState('zfb', id);
              $this.payTimeNum = $this.payTimeNum + 1;
              // }
            }, 3000);

          } else {
            this.$message.error(data.message);
          }

        })
      },
      payOpenYl: function(id, cname, price, bizType) {
        var $this = this;
        var yl = {
          "out_trade_no": id,
          "subject": cname,
          "total": price,
          "bizType": bizType
        }
        // 生成微信支付订单
        this.$axios.post('/prevention/pay/YL.htm', yl, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            'Content-Type': 'application/json;charset=utf8'
          }
        }).then(res => {
          var data = res.data;
          this.loading = false;
          if (data && data.data && data.data.body) {
            localStorage.setItem('payYlHTML', data.data.body);

            let {
              href
            } = this.$router.resolve({
              path: '/YlPay'
            })
            window.open(href, '_blank')
            var $this = this;
            this.payTimeNum = 0;
            // 支付状态查询
            this.payTimeInter = setInterval(function() {
              $this.getPayState('yl', id, data.data.txntime);
              $this.payTimeNum = $this.payTimeNum + 1;
              // if ($this.payTimeNum == 10) {
              //   clearInterval($this.payTimeInter);
              //   $this.payTimeInter = null;
              //   //  payitype (支付方式 )支付方式 1 微信 2 支付宝 3 银联
              //   $this.changeOrderState(id,3)
              // }
            }, 10000);
          } else {
            this.$message.error(data.message);
          }
        })
      },
      getPayState: function(flag, out_trade_no, txntime) {
        var url = '/prevention/pay/getZXZFStatus.htm?flag=' + flag + '&out_trade_no=' + out_trade_no;
        if (flag == 'yl') {
          url += '&txntime' + txntime;
        }
        this.$axios.get(url, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data && data.data && data.data == "success") {
            clearInterval(this.payTimeInter);
            this.payTimeInter = null;
            this.changeOrderState(out_trade_no)
          }
        })
      },
      getData: function(id) {
        this.$axios.get('/kt/wz/productInfo/getProdcutallDetail.htm?id=' + id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.productInfo = data.data;
            // this.changeOrderState(this.orderNum,'1')
          } else {
            this.$message.error(data.message);
          }
        })
      },
      bindQRCode: function(url, id) {
        // weixin://wxpay/bizpayurl?pr=FiNXfdezz
        new QRCode(this.$refs.qrCodeDiv, {
          text: url,
          width: 260,
          height: 260,
          iconSrc: "/static/images/zhawlogol.png",
          iconRadius: 0,
          iconBorderWidth: 3,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        });
        var $this = this;
        this.payTimeInter = setInterval(function() {
          $this.getPayState('wx', id);
          $this.payTimeNum = $this.payTimeNum + 1;
          // if ($this.payTimeNum == 10) {
          //   clearInterval($this.payTimeInter);
          //   $this.payTimeInter = null;
          //   $this.changeOrderState(id,1)
          // }
        }, 3000);
      },
      changeTjstate:function(state){
        $('#Eweima').html("")
        this.notTj=state;
      },
      // 修改订单的状态  订单支付成功  返回订单详情页面
      changeOrderState:function(id){
        this.$axios.post('/kt/ktProductBuy/update.htm',this.$qs.stringify({id:id,state:1,payitype:this.payitype}), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            // this.$router.push('/ProductDetail?id='+this.productInfo.id);
            this.$router.go(-1);
          } else {
            this.$message.error(data.message);
          }
        })
      }
    },
    created: function() {
      // 获取订单详情
      this.$axios.get('/kt/ktProductBuy/detail.htm?id=' + this.$route.query.id, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        }
      }).then(res => {
        var data = res.data;
        this.num=data.data.buyamount;
        this.orderNum=this.$route.query.id;
        this.payitype=data.data.payitype;
        this.getData(data.data.productid);
      })
    },
  }
</script>

<style>
  .order-div {}

  .order-div-cy {
    /* position: fixed;
    top: 57px; */
    height: 50px;
    opacity: 1;
    background: #ffffff;
    left: 0;
    margin-bottom: 20px;
  }

  .order-div-cy-div {
    width: 1250px;
    color: #9a9a9a;
    margin: 0 auto;
    line-height: 50px;
    text-align: left;
    font-size: 14px;
  }

  .order-div-nr {
    width: 1200px;
    opacity: 1;
    background: #ffffff;
    border-radius: 12px;
  }

  .order-div-nr .el-card.is-always-shadow {
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
  }

  .order-div-nr .el-card__header {
    text-align: left;
  }

  .order-div-nr th {
    background-color: #efefef;
  }

  .text.item {
    text-align: left;
  }

  .orderList {
    margin: 20px 0 20px;
  }

  .goodsXq {
    text-align: left;
    margin-left: 17px;
    width: 377px;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: space-between;
  }

  .priceYouhui {
    width: 140px;
    line-height: 35px;
  }

  .flex1.pay {
    width: 198px;
    height: 51px;
    opacity: 1;
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    margin-right: 20px;
    line-height: 51px;
    cursor: pointer;
    text-align: center;
  }

  .flex1.pay.active {
    border: 1px solid #0071BA;
    color: #0071BA;
    position: relative;
  }

  .flex1.pay.active::after {
    content: " ";
    display: inline-block;
    width: 0;
    height: 0;
    border-bottom: 18px solid #0071BA;
    border-left: 18px solid transparent;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .cardFooter {
    border-top: 1px solid #efefef;
    padding: 25px 20px;
    text-align: right;
  }

  .shouldPay {
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #4a4a4a;
    letter-spacing: 1px;
  }

  .shouldMoney {
    font-size: 30px;
    font-family: DINAlternate, DINAlternate-Bold;
    font-weight: 700;
    color: #d50000;
    letter-spacing: 2px;
    padding-right: 28px;
  }

  .cardFooter .disFlex {
    justify-content: flex-end;
    align-items: center;
  }

  #Eweima {
    height: 260px;
    width: 260px;
    margin: 20px auto;
  }

  .sysbtn {
    background: #00C702;
    color: #fff;
    height: 46px;
    text-align: center;
    line-height: 46px;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrderInfo.vue